import { PropertyTypes } from "../../../../enums/PropertyTypes";
import { ISchema, ISchemaChild, ISchemaFilter, ISchemaProperty } from "../Schema";
import { EntityNames } from "../../../../enums/EntityNames";
import { EntityViewTypes } from "../../../../enums/EntityViewTypes";
import { FilterTypes } from "../../../../enums/FilterTypes";
import { FilterMatchType } from "../../../../enums/FilterMatchType";
import SidePanelRecallLineItem from "../../layout/SidePanel/layouts/SidePanelRecallLineItem";
import React from "react";

export const RecallLineItemsSchema: ISchema = {
    displayName: "Recalls",
    GetSidePanelComponent: (data, onViewPage) => <SidePanelRecallLineItem data={data} onViewPage={onViewPage} />,
    props: [
        {
            name: 'id',
            type: PropertyTypes.string,
            key: true
        } as ISchemaProperty,
        {
            name: 'reference',
            displayName: 'Reference',
            type: PropertyTypes.string,
            key: false,
            descriptor: true,
            showInList: true,
            showInForm: false,
            showInView: false,
        } as ISchemaProperty,
        {
            name: 'year',
            displayName: 'Year',
            type: PropertyTypes.year,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            valueFormatter: (val: number) => {
                return val === 0 ? '--' : val;
            }
        } as ISchemaProperty,
        {
            name: 'typeName',
            displayName: 'Type',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
        } as ISchemaProperty,
        {
            name: 'intent',
            displayName: 'Contents',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
        } as ISchemaProperty,
        {
            name: 'status',
            displayName: 'Status',
            type: PropertyTypes.status,
            showInList: true,
            showInForm: false,
            showInView: false,
        } as ISchemaProperty,
    ],
    primaryFilter: {
        PropertyName: "Reference",
        displayName: "Search",
        type: FilterTypes.search,
        required: false,
        className: "width--full",
        matchType: FilterMatchType.Equal,
        propertyType: PropertyTypes.string,
        placeHolder: "Enter an item reference"
    } as ISchemaFilter,

    filters: [
        {
            PropertyName: "Year",
            displayName: "Year",
            type: FilterTypes.year,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.year,
            showInTab: true
        } as ISchemaFilter,
        {
            PropertyName: "CaseMaterialTypeId",
            entityName: "caseMaterialTypes",
            displayName: "Material Type",
            type: FilterTypes.select,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.uuid,
            showInTab: true
        } as ISchemaFilter,
    ] as ISchemaFilter[],

    children: [{ entityName: EntityNames.recallLineItems, displayName: "Items", cantView: false, viewType: EntityViewTypes.list, enableFilters: true, navPropertyName: "RecallId", canAdd: false } as ISchemaChild,],
};
